import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";

type TProgress = {
  progress: number;
  status: "uploading" | "completed" | "errored";
  message?: string | null;
};

export type TFileProgresses = Record<string, TProgress>;

export const fileProgresses = atom<TFileProgresses>({});

export const setFileProgressesAtom = () => {
  return useSetAtom(fileProgresses);
};

export const fileProgressesAtom = () => {
  return useAtomValue(fileProgresses);
};

export const useFileProgressesAtom = () => {
  return useAtom(fileProgresses);
};
